<template>
  <p>數值 Numeric：{{ rangeBarValue }}</p>
  <CFormRange
    :id="id"
    :disabled="+info.is_help"
    :min="info.extension_info.min"
    :max="info.extension_info.max"
    :model-value="
      rangeBarValue ? String(rangeBarValue) : String(info.extension_info.min)
    "
    @change="emitContent"
  />
  <div class="d-flex justify-content-between">
    <p>{{ info.extension_info.min }}</p>
    <p>{{ info.extension_info.max }}</p>
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const rangeBarValue = ref(String(props.info.extension_info.min))
    const emitContent = (e) => {
      rangeBarValue.value = e?.target.value || null
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: +rangeBarValue.value > +props.info.extension_info.min,
        value_info:  !+props.info.is_help ? rangeBarValue.value : null,
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newValue) => {
        emitContent({ target: { value: newValue } })
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      emitContent,
      rangeBarValue,
    }
  },
}
</script>
